module.exports = __webpack_public_path__ + "img/crock-pot-banana-nut-bread.ae60cff5.jpg";